import apiClient from "../api/apiClient";

const TENANT_ID = process.env.REACT_APP_TENANT_ID ?? "1";

export interface BundlePricing {
    id: number;
    classId: number;
    className: string;
    subjectCount: number;
    price: number;
}

export interface BundlePricingPayload {
    classId: number;
    subjectCount: number;
    price: number;
}

export async function getBundlePricing(classId: number): Promise<BundlePricing[]> {
    const resp = await apiClient.get("/admin/bundle-pricing", {
        params: { classId, tenantId: TENANT_ID },
    });
    return resp.data;
}

export async function createBundlePricing(payload: BundlePricingPayload): Promise<BundlePricing> {
    const resp = await apiClient.post("/admin/bundle-pricing", payload, {
        params: { tenantId: TENANT_ID },
    });
    return resp.data;
}

export async function updateBundlePricing(id: number, payload: BundlePricingPayload): Promise<BundlePricing> {
    const resp = await apiClient.put(`/admin/bundle-pricing/${id}`, payload, {
        params: { tenantId: TENANT_ID },
    });
    return resp.data;
}

export async function deleteBundlePricing(id: number): Promise<void> {
    await apiClient.delete(`/admin/bundle-pricing/${id}`, {
        params: { tenantId: TENANT_ID },
    });
}
